// ResponsiveProforma.jsx → src/gestion-proforma/
import React from "react";
import GestionProforma from "./GestionProforma";
import ProformaMobile from "../mobile/ventes/ProformaMobile";
import useIsMobile from "../hooks/useIsMobile";

export default function ResponsiveProforma(props) {
  return useIsMobile() ? <ProformaMobile {...props} /> : <GestionProforma {...props} />;
}
